import React from "react"
import { useToggle } from "../../../../utils/Hooks"
import { FormattedMessage, FormattedNumber, useIntl } from "react-intl"
import EmployeeOnlyModalContainer from "../../../employee-only-containers/EmployeeOnlyModalContainer"
import {
  Dialog,
  Box,
  DialogTitle,
  IconButton,
  CloseIcon,
  DialogContent,
  DialogContentText,
  Typography
} from "@carrotfertility/carotene-core"
// eslint-disable-next-line no-restricted-imports
import { Icon } from "@carrotfertility/carotene" // please do not import from @carrotfertility/carotene after eslint rule added on 3/20/25
import { useSelector } from "react-redux"
import { getCompanyCurrencyCode } from "#/redux/reducers/companyInfo"
import { ExpenseState } from "../../../../utils/ExpenseState"
import { ExpenseType } from "#/utils/ExpenseType"

const TransactionAmounts = ({
  // @ts-expect-error TS(7031) FIXME: Binding element 'id' implicitly has an 'any' type.
  id,
  // @ts-expect-error TS(7031) FIXME: Binding element 'style' implicitly has an 'any' ty... Remove this comment to see the full error message
  style,
  // @ts-expect-error TS(7031) FIXME: Binding element 'primaryAmount' implicitly has an ... Remove this comment to see the full error message
  primaryAmount,
  // @ts-expect-error TS(7031) FIXME: Binding element 'primaryCurrencyCode' implicitly h... Remove this comment to see the full error message
  primaryCurrencyCode,
  // @ts-expect-error TS(7031) FIXME: Binding element 'secondaryAmount' implicitly has a... Remove this comment to see the full error message
  secondaryAmount,
  // @ts-expect-error TS(7031) FIXME: Binding element 'secondaryCurrencyCode' implicitly... Remove this comment to see the full error message
  secondaryCurrencyCode
}) => {
  const intl = useIntl()
  if (secondaryAmount == null || secondaryCurrencyCode == null) {
    return (
      <span id={id} style={{ fontWeight: "bold", ...style }}>
        <FormattedNumber
          value={primaryAmount}
          // eslint-disable-next-line react/style-prop-object -- style prop is valid for FormattedNumber
          style="currency"
          currency={primaryCurrencyCode}
          currencyDisplay="narrowSymbol"
        />
      </span>
    )
  }
  return (
    <span id={`${id}-with-secondary`} style={{ fontWeight: "bold", ...style }}>
      <FormattedMessage
        defaultMessage="{primaryAmount} <span>({secondaryAmount})</span>"
        values={{
          primaryAmount: intl.formatNumber(primaryAmount, {
            style: "currency",
            currency: primaryCurrencyCode,
            currencyDisplay: "narrowSymbol"
          }),
          secondaryAmount: intl.formatNumber(secondaryAmount, {
            style: "currency",
            currency: secondaryCurrencyCode,
            currencyDisplay: "narrowSymbol"
          }),
          span: (spanContent) => (
            <Box component="span" sx={(theme) => ({ color: theme.palette.text.tertiary })}>
              {spanContent}
            </Box>
          )
        }}
        description={"Amount of a transaction in a primary and secondary currency"}
      />
    </span>
  )
}

// @ts-expect-error TS(7031) FIXME: Binding element 'reimbursement' implicitly has an ... Remove this comment to see the full error message
export const ReimbursementAmount = ({ reimbursement }) => {
  const [isAmountsModalOpen, toggleIsAmountsModalOpen] = useToggle(false)
  const intl = useIntl()
  const AmountsInfoModal = () => (
    <EmployeeOnlyModalContainer onClose={toggleIsAmountsModalOpen}>
      <Dialog
        open={isAmountsModalOpen}
        onClose={toggleIsAmountsModalOpen}
        aria-labelledby="amounts-info-modal-title"
        aria-describedby="amounts-info-modal-description"
      >
        <Box display="flex" justifyContent="flex-end">
          <IconButton
            aria-label={intl.formatMessage({ defaultMessage: "close" })}
            onClick={() => toggleIsAmountsModalOpen()}
          >
            <CloseIcon />
          </IconButton>
        </Box>
        <DialogTitle id="amounts-info-modal-title">
          <FormattedMessage defaultMessage="What is this amount?" />
        </DialogTitle>
        <DialogContent>
          <Box
            sx={(theme) => ({ marginBlockStart: theme.tokens.spacing.lg, marginBlockEnd: theme.tokens.spacing.xxxl })}
          >
            <DialogContentText id="amounts-info-modal-description">
              <FormattedMessage defaultMessage="The number in parentheses is the currency you paid in." />
            </DialogContentText>
          </Box>
        </DialogContent>
      </Dialog>
    </EmployeeOnlyModalContainer>
  )

  const displayAdjustedAmount =
    reimbursement.adjustmentDatetime &&
    reimbursement.originalAmount &&
    reimbursement.originalAmount !== reimbursement.amount

  const displayAmountInMerchantCurrency = reimbursement.currencyCode !== reimbursement.merchantCurrency
  const companyCurrencyCode = useSelector(getCompanyCurrencyCode)
  const pendingDisplayAmount = intl
    .formatNumber(0.0, {
      style: "currency",
      currency: companyCurrencyCode,
      currencyDisplay: "narrowSymbol"
    })
    .replaceAll("0", "-")
  return reimbursement.expenseType !== ExpenseType.CARD &&
    (reimbursement.expenseState === ExpenseState.RECEIVED || reimbursement.expenseState === ExpenseState.ON_HOLD) ? (
    <Typography variant="body2" fontWeight="bold">
      {pendingDisplayAmount}
    </Typography>
  ) : (
    <>
      <Box sx={{ flexDirection: "column" }}>
        <Typography variant="body2" fontWeight="bold">
          {displayAdjustedAmount && (
            <>
              <TransactionAmounts
                id="adjusted-transaction-amount"
                primaryAmount={reimbursement.originalAmount / 100}
                primaryCurrencyCode={reimbursement.currencyCode}
                secondaryAmount={
                  displayAmountInMerchantCurrency ? reimbursement.originalAmountInMerchantCurrency / 100 : null
                }
                secondaryCurrencyCode={displayAmountInMerchantCurrency ? reimbursement.merchantCurrency : null}
                style={{ textDecoration: "line-through" }}
              />
              {/* @ts-expect-error TS(2322) FIXME: Type '{ name: string; color: "rgba(0, 0, 0, 0.4)";... Remove this comment to see the full error message */}
              <Icon name="rightArrow" color="rgba(0, 0, 0, 0.4)" size="10px" style={{ margin: "0 8px" }} />
            </>
          )}
          {/* @ts-expect-error TS(2741) FIXME: Property 'style' is missing in type '{ id: string;... Remove this comment to see the full error message */}
          <TransactionAmounts
            id="transaction-amount"
            primaryAmount={reimbursement.amount / 100}
            primaryCurrencyCode={reimbursement.currencyCode}
            secondaryAmount={displayAmountInMerchantCurrency ? reimbursement.amountInMerchantCurrency / 100 : null}
            secondaryCurrencyCode={displayAmountInMerchantCurrency ? reimbursement.merchantCurrency : null}
          />
        </Typography>
      </Box>
      {displayAmountInMerchantCurrency ? (
        <Box sx={{ flexDirection: "column" }}>
          <Box
            component="button"
            id="btn-merchant-amount-more-info"
            sx={{
              marginBlock: 0,
              marginInline: "4px",
              border: "none",
              display: "flex",
              borderRadius: "100%",
              padding: "4px",
              cursor: "pointer",
              backgroundColor: (theme) => theme.palette.common.white,
              "&:hover, &:focus": { backgroundColor: "#f5f5f5" }
            }}
            aria-label={intl.formatMessage({
              defaultMessage: "Learn more about these amounts"
            })}
            onClick={() => toggleIsAmountsModalOpen()}
          >
            <Icon name="helpCircle" color="rgba(0, 0, 0, 0.6)" size="12px" />
          </Box>
        </Box>
      ) : null}
      {isAmountsModalOpen && <AmountsInfoModal />}
    </>
  )
}
